import axios from "../libs/axios";
import authHeader from "./auth-header";

const API_URL = `${process.env.VUE_APP_API_ENDPOINT}/v1`;

//  app.get("/api/v1/allocation-entries", verifyToken, controller.find);
//  app.post("/api/v1/allocation-entry", verifyToken, controller.create);
//  app.get("/api/v1/allocation-entry/:id", verifyToken, controller.findByID);
//  app.put("/api/v1/allocation-entry/:id", verifyToken, controller.update);
//  app.delete("/api/v1/allocation-entry/:id", verifyToken, controller.remove);

class AllocationEntryService {
  find(params) {
    return axios.get(`${API_URL}/allocation-entries`, {
      headers: authHeader(),
      params,
    });
  }

  create(data) {
    return axios.post(`${API_URL}/allocation-entry`, data, {
      headers: authHeader(),
    });
  }
  findByID(id) {
    return axios.get(`${API_URL}/allocation-entry/${id}`, {
      headers: authHeader(),
    });
  }

  update(data) {
    const _id = data._id;
    return axios.put(`${API_URL}/allocation-entry/${_id}`, data, {
      headers: authHeader(),
    });
  }

  delete(id) {
    console.log("delete", id);
    return axios.delete(`${API_URL}/allocation-entry/${id}`, {
      headers: authHeader(),
    });
  }
  entries(allocation_id, params) {
    console.log("entries", params);
    return axios.post(
      `${API_URL}/allocation-entries/${allocation_id}`,
      params,
      {
        headers: authHeader(),
      },
    );
  }
}

export default new AllocationEntryService();
